import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { responsiveStyles } from '../../utils/responsiveStyles';
import { mapStyle } from '../../utils/mapStyle';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { AlignMap } from './LayoutItem.types';
export var StyledLayoutItem = styled.div(_templateObject(), function (props) {
  return responsiveStyles({
    'align-self': mapStyle(props.align, AlignMap),
    'flex-basis': props.basis,
    'flex-grow': props.grow,
    'flex-shrink': props.shrink
  }, props.theme.breakpoints);
}, injectSpacing('margin'));